// extracted by mini-css-extract-plugin
export default {"root":"ProfileSettings_root__MKBa1","base":"ProfileSettings_base__vkcFV"};